import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CubicBezier } from '../config/global'

export default class Scroll {
	constructor(triggers, from, to) {
		if (!triggers.length) return

		this.triggers = triggers
		this.from = from
		this.to = to
		this.getDom()

		if (!this.dom.triggers.length) return

		gsap.registerPlugin(ScrollTrigger);
		
		this.init()
	}

	getDom() {
		if (this.triggers.length) {
			this.dom = {
				triggers: this.triggers
			}
		}
	}

	init() {
		this.dom.triggers.forEach((trigger) => {
			gsap.fromTo(trigger, {
				...this.from,
			},
			{
				...this.to,
				duration: trigger.dataset.time ? trigger.dataset.time : this.to.duration,
				delay: trigger.dataset.delay ? trigger.dataset.delay : 0,
				ease: CubicBezier,
				scrollTrigger: {
					once: true,
					trigger: trigger,
					start: 'top bottom-=15%',
				},
			})
		})
	}
}